var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './Dropdown.module.scss';
import { ArrowDown } from '../../assets/icons';
import { DropdownList } from '../DropdownList/DropdownList';
var Dropdown = function (_a) {
    var label = _a.label, selected = _a.selected, options = _a.options, right = _a.right, small = _a.small, smallText = _a.smallText, dropUp = _a.dropUp, noMargin = _a.noMargin, showSelected = _a.showSelected, className = _a.className, id = _a.id, dataId = _a.dataId, onChange = _a.onChange;
    var isMounted = useRef(true);
    var _b = useState(false), opened = _b[0], setOpened = _b[1];
    useEffect(function () {
        return function () {
            isMounted.current = false;
        };
    }, []);
    var classes = "".concat(opened ? styles.Active : '', " ").concat(small ? styles.Small : '', " ").concat(smallText ? styles.SmallText : '', " ").concat(noMargin ? styles.NoMargin : '');
    var onDropdownChange = function (value) {
        onChange && onChange(value);
        isMounted.current && setOpened(false);
    };
    var onClose = function () {
        setOpened(false);
    };
    return (_jsx("div", __assign({ id: id, className: "".concat(styles.DropdownContainer, " ").concat(dropUp ? styles.DropUp : '', " ").concat(className ? className : '') }, { children: _jsxs("div", __assign({ className: "".concat(styles.DropdownWrapper, " ").concat(right ? styles.Right : ''), onClick: function () { return !opened && setOpened(true); }, "data-testid": dataId }, { children: [_jsxs("div", __assign({ className: "".concat(styles.Dropdown, " ").concat(classes) }, { children: [label, !!showSelected && _jsx("span", __assign({ className: styles.Selected }, { children: selected === null || selected === void 0 ? void 0 : selected.label })), _jsx("i", __assign({ className: styles.Icon }, { children: _jsx(ArrowDown, {}) }))] })), opened && (_jsx(DropdownList, { options: options, selected: selected, className: styles.DropdownList, onSelect: onDropdownChange, onClose: onClose }))] })) })));
};
Dropdown.propTypes = {
    label: PropTypes.string.isRequired,
    selected: PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
    }),
    options: PropTypes.arrayOf(PropTypes.any).isRequired,
    small: PropTypes.bool,
    smallText: PropTypes.bool,
    dropUp: PropTypes.bool,
    noMargin: PropTypes.bool,
    right: PropTypes.bool,
    showSelected: PropTypes.bool,
    className: PropTypes.string,
    id: PropTypes.string,
    dataId: PropTypes.string,
    onChange: PropTypes.func,
};
export { Dropdown };
//# sourceMappingURL=Dropdown.js.map